<template>
  <div class="tmac_desc">
    <v-container>
      <div class="heading text-h6 text-sm-h4 mt-4 font-weight-bold pl-4">
        TMAK概要説明
      </div>

    <v-row class="mt-2" justify="center">
        <v-col cols="12" md="10">
            <v-carousel class="carousel" height="auto" hide-delimiters>
              <v-carousel-item v-for="(item, i) in desc_items" :key="i" eager>
                <v-img :src="item.src" height="100%" eager/>
              </v-carousel-item>
            </v-carousel>
        </v-col>
    </v-row>

    <div class="heading text-h6 text-sm-h4 mt-4 font-weight-bold pl-4">
        プロジェクト説明
    </div>

    <v-row class="mt-2" justify="center">
        <v-col cols="12" md="10">
            <v-carousel class="carousel" height="auto" hide-delimiters>
              <v-carousel-item v-for="(item, i) in proj_items" :key="i" eager>
                <v-img :src="item.src" height="100%" eager/>
              </v-carousel-item>
            </v-carousel>
        </v-col>
    </v-row>

    </v-container>
  </div>
</template>

<script>
import desc_img from '@/components/data/desc_carousel_imeges.js'
import proj_img from '@/components/data/proj_carousel_imeges.js'

export default {
  name: "Description",
  data: () => ({
    desc_items: desc_img.images,
    proj_items: proj_img.images,
  }),
};
</script>

<style scoped>
.heading {
  border-bottom: 2px solid #000;
}
</style>